/**
 * @generated SignedSource<<129434fbbd547c0f3997a4b24d945067>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteEditSeo_seoRoute$data = {
  readonly h1: string | null;
  readonly id: string;
  readonly metaDescription: string | null;
  readonly metaTitle: string | null;
  readonly promoLinkTitle: string | null;
  readonly promoLinkUrl: string | null;
  readonly promoText: string | null;
  readonly " $fragmentType": "SeoRouteEditSeo_seoRoute";
};
export type SeoRouteEditSeo_seoRoute$key = {
  readonly " $data"?: SeoRouteEditSeo_seoRoute$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoRouteEditSeo_seoRoute">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoRouteEditSeo_seoRoute",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "h1",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promoText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promoLinkTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promoLinkUrl",
      "storageKey": null
    }
  ],
  "type": "SeoRoute",
  "abstractKey": null
};

(node as any).hash = "2afdd6489656f9de98f6b618b0acbb9d";

export default node;
